import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import ArrowLoadingIndicator from '~/icons/components/ArrowLoadingIndicator';
import WhitelabelIcon from '~/icons/components/WhitelabelIcon';

const LoadingSpinner = styled(ArrowLoadingIndicator)`
  fill: ${({ theme: { colors } }) => colors.white};
  margin: 0 auto;
  height: 32px;
  width: 32px;
`;

const ErrorIcon = styled.div`
  background: ${({ theme: { colors } }) => colors.error};
  padding: 12px 12px 12px 14px;
  border-radius: 100%;
  margin: 0 auto;
  height: 60px;
  width: 60px;
`;

const AlertTriangle = styled(WhitelabelIcon).attrs({
  iconName: 'alertTriangle',
  color: 'white',
  size: '30px',
})``;

const EmbroideryPreviewImage = ({ error, previewImageSrc, isLoading }) => {
  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return (
      <ErrorIcon>
        <AlertTriangle />
      </ErrorIcon>
    );
  }

  if (previewImageSrc) {
    const imgSrc = `data:image/png;base64, ${previewImageSrc}`;
    return <img src={imgSrc} alt="Preview Text" />;
  }

  return null;
};

EmbroideryPreviewImage.propTypes = {
  error: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  previewImageSrc: PropTypes.string.isRequired,
};

export default EmbroideryPreviewImage;
